import FormGroup, {
  FormGroupProps as RSFormGroupProps,
} from 'reactstrap/lib/FormGroup';

export type FormGroupProps = RSFormGroupProps;

export default FormGroup;
